import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { toggleMark } from 'prosemirror-commands';
import { icons, MenuItem } from 'prosemirror-menu';
import { MarkType, Schema } from 'prosemirror-model';
import { EditorState } from 'prosemirror-state';

import { ProsemirrorLinkModalComponent } from '../../prosemirror-link-modal/prosemirror-link-modal.component';

const cmdItem = (cmd, options) => {
  return new MenuItem({
    ...options,
    run: cmd,
    enable: state => cmd(state),
  });
};

const markActive = (state: EditorState, type: MarkType) => {
  const { from, $from, to, empty } = state.selection;
  if (empty) {
    return type.isInSet(state.storedMarks || $from.marks());
  } else {
    return state.doc.rangeHasMark(from, to, type);
  }
};

export function markItem(markType: MarkType, options) {
  const passedOptions = {
    active(state) {
      return markActive(state, markType);
    },
    enable: true,
  };

  Object.keys(options).forEach(prop => (passedOptions[prop] = options[prop]));

  return cmdItem(toggleMark(markType), passedOptions);
}

export function linkItem(markType: MarkType, modal: NgbModal) {
  return new MenuItem({
    title: 'Link',
    icon: icons.link,
    class: undefined,
    css: undefined,

    active(state) {
      return !!markActive(state, markType);
    },
    enable(state) {
      return !state.selection.empty;
    },
    run(state, dispatch, view) {
      if (markActive(state, markType)) {
        toggleMark(markType)(state, dispatch);
        return true;
      } else {
        modal
          .open(ProsemirrorLinkModalComponent, {
            centered: true,
            windowClass: 'centered-modal-window',
          })
          .result.then(
            link => {
              toggleMark(markType, { href: link, class: 'll' })(
                view.state,
                view.dispatch,
              );
              view.focus();
            },
            () => {
              view.focus();
            },
          );
        return false;
      }
    },
  });
}

export interface InlineMenuOptions {
  modal: NgbModal;
}

export function inlineMenu(schema: Schema, options: InlineMenuOptions) {
  return [
    markItem(schema.marks.strong, {
      title: 'Bold',
      label: ' ',
      class: 'ProseMirror-icon-bold',
    }),
    markItem(schema.marks.em, {
      title: 'Italic ',
      label: ' ',
      class: 'ProseMirror-icon-italic',
    }),
    linkItem(schema.marks.link, options.modal),
  ];
}
